import {Button, ButtonProps, IconButton} from '@mui/material';
import { styled } from '@mui/material/styles';

export const LightHoverButton = styled((props: ButtonProps) => (
    <Button variant="contained" disableRipple {...props} />
))(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
    },
}));

export const SecondaryButton = styled((props: ButtonProps) => (
    <Button variant="contained" disableRipple {...props} />
))(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
        backgroundColor: theme.palette.secondary.light,
    },
    '&.Mui-disabled': {
        backgroundColor: theme.palette.custom.customDisabledGray,
        color: 'white',
    },
}));

export const PrimaryIconButton = styled((props: ButtonProps) => (
    <IconButton variant="contained" disableRipple {...props} />
))(({ theme }) => ({
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
    '&:hover': {
        color: theme.palette.secondary.light,
        backgroundColor: 'transparent',
    },
    '&.Mui-disabled': {
        color: theme.palette.custom.customDisabledGray,
        backgroundColor: 'transparent',
    },
}));

export const SecondaryIconButton = styled((props: ButtonProps) => (
    <IconButton variant="contained" disableRipple {...props} />
))(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
        backgroundColor: theme.palette.secondary.light,
    },
    '&.Mui-disabled': {
        backgroundColor: theme.palette.custom.customDisabledGray,
        color: 'white',
    },
}));